import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading-component',
  templateUrl: './loading-component.component.html',
  styleUrls: ['./loading-component.component.css']
})
export class LoadingComponentComponent implements OnInit {

  title: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: string,
    private matDialog: MatDialogRef<LoadingComponentComponent>
  ) { }

  ngOnInit(): void {
    this.title = this.data;
  }

}
